/** Раздел «Раскладка паллет» — своя ручка и своё право (`order_plan`).
 *
 * Отдельно от `order_check` намеренно: раскладку правит старший склада, а
 * право сборки есть у каждого сборщика. Данные считает тот же серверный
 * модуль — второй реализации сверки нет. */
import { api } from "@/api/client";
import type { OrderListResponse, PlanReview, RefName } from "@/api/order_check";

// Бэкенд принимает `?kind=transfer` (раскладка перемещений), но экран пока осознанно
// поддерживает только заказы покупателей.
export async function listPlanOrders(params: {
  q?: string;
  organization_ref?: string;
  state_ref?: string;
  check_status?: string;
  /** Дата отгрузки `yyyy-mm-dd`: только заказы с отгрузкой в этот день. */
  ship_date?: string;
  skip?: number;
}): Promise<OrderListResponse> {
  const { data } = await api.get<OrderListResponse>("/order-plan/orders", {
    params: {
      q: params.q || undefined,
      organization_ref: params.organization_ref || undefined,
      state_ref: params.state_ref || undefined,
      check_status: params.check_status || undefined,
      ship_date: params.ship_date || undefined,
      skip: params.skip || undefined,
    },
  });
  return data;
}

export async function listPlanOrganizations(q?: string): Promise<RefName[]> {
  const { data } = await api.get<RefName[]>("/order-plan/organizations", {
    params: { q: q || undefined },
  });
  return data;
}

export async function listPlanOrderStates(): Promise<RefName[]> {
  const { data } = await api.get<RefName[]>("/order-plan/order-states");
  return data;
}

export async function getPlanReview(orderRef: string): Promise<PlanReview> {
  const { data } = await api.get<PlanReview>(`/order-plan/orders/${orderRef}`);
  return data;
}

export interface PlanSaveLine {
  nomenclature_ref: string;
  characteristic_ref: string;
  partia_ref: string;
  qty: number;
  boxes: number;
}

export interface PlanSavePallet {
  /** id планового места живого плана (`PlanReviewPallet.ref`); пусто — новая паллета. */
  ref: string;
  lines: PlanSaveLine[];
}

export interface PlanSaveResult {
  updated: number;
  created: number;
  deleted: number;
  /** SSCC заведённых паллет (их печатают на этикетках). */
  new_numbers: string[];
  review: PlanReview;
}

export async function savePlan(
  orderRef: string,
  pallets: PlanSavePallet[],
): Promise<PlanSaveResult> {
  const { data } = await api.put<PlanSaveResult>(`/order-plan/orders/${orderRef}`, {
    pallets,
  });
  return data;
}
